// @ts-nocheck
import React from 'react';

export type BulkItem = {
  url: string;
  status: 'Queued'|'Extracting'|'Enriched'|'Saved'|'Needs review'|'Error';
  message?: string;
};

export default function BulkAddDialog({ open, onClose, onSubmit }: { open: boolean; onClose: ()=>void; onSubmit: (urls: string[])=>void }) {
  const [text, setText] = React.useState('');

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 w-[min(720px,calc(100%-24px))] p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="font-semibold">Bulk add links</div>
          <button onClick={onClose} className="px-2 py-1 text-sm rounded hover:bg-gray-100 dark:hover:bg-gray-800">Close</button>
        </div>
        <textarea
          className="w-full h-48 rounded-lg border border-gray-300 dark:border-gray-700 bg-transparent p-2 text-sm"
          placeholder="Paste or type multiple links (one per line)"
          value={text}
          onChange={(e)=>setText(e.target.value)}
        />
        <div className="mt-3 flex items-center justify-between">
          <div className="text-xs text-gray-500">We accept most video links; unsupported ones will be flagged with help.</div>
          <button
            onClick={()=>{
              const urls = Array.from(new Set(text.split(/\s+/g).map(s=>s.trim()).filter(Boolean)));
              onSubmit(urls);
            }}
            className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
          >Queue {text ? text.split(/\n/).filter(Boolean).length : 0}</button>
        </div>
      </div>
    </div>
  );
}
